

import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/*
  este arquivo contém funções para arrays
*/

@Injectable({
  'providedIn': 'root'
})

export class GeneralHelper {

  /*
    gera id aleatório
  */
  guid(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*(16)|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });
  }

  dateTimeBR(date){
    return new Date(date).toLocaleString();
  }

  toCurrency(value: number){
      // return (value == null) ? 0 : value.toFixed(2).toString().replace('.', ',');
      return (value == null) ? '0,00' : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }


  /*
    pega tipo do arquivo de base64 para
  */
  getFileTypeFromBase64(base64: string): string {
    let type = base64.charAt(0);
    if (type == '/') {
      return 'jpg'
    } else if(type == 'i') {
      return 'png';
    } else if(type == 'R') {
      return 'gif';
    } else if(type == 'U') {
      return 'webp';
    }
    return 'jpg';
  }

  /*
    constrói query para enviar para api
  */
  buildQuery(obj: any) {
      var str: string[] = [];
      for (var p in obj){
        if(Array.isArray(obj[p])){
          for(let i=0; i < obj[p].length; i ++){
            str.push(encodeURIComponent(p+'[]') + "=" + encodeURIComponent(obj[p][i]));
          }
        }
        else if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      }
      return str.join("&");
  }

}
